import React from 'react';
import { cn } from '~/helpers/utils';
import { Controller, useFormContext } from 'react-hook-form';
import IncomeCalculation from '~/components/forms/Tools/CalculateMaximumMortgage/IncomeCalculation';
import FormattedNumberInput from '~/components/forms/FormattedNumberInput';

type IncomeFieldWithCalculatorProps = {
  name: string;
  label?: string;
  labelClass?: string;
  placeholder?: string;
}

const IncomeFieldWithCalculator: React.FC<IncomeFieldWithCalculatorProps> = ({
  name,
  label,
  labelClass,
  placeholder,
}) => {
  const { control, trigger } = useFormContext();

  const inputId: string = `field-${name}`;

  return (
    <div className="form-control">
      {label && (
        <label htmlFor={inputId} className={cn('form-label', labelClass)}>
          {label}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <>
            <FormattedNumberInput
              {...field}
              id={inputId}
              placeholder={placeholder}
              className="!pr-10"
              hasError={!!fieldState.error}
              suffixComponent={
                <IncomeCalculation
                  onHandleCalculate={async (val) => {
                    field.onChange(val);
                    await trigger(field.name);
                  }}
                />
              }
            />
            {fieldState.error && (
              <span className="text-sm text-tomato-600">{fieldState.error.message}</span>
            )}
          </>
        )}
      />
    </div>
  );
};

export default IncomeFieldWithCalculator;
